import React, { HTMLProps } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { IAppState } from 'src/store';
import './styles.scss';

const Icon: React.FC<Props> = ({ name, className, ...props }) => {
  const iconName = `icon-${name}`;

  return <i className={cn(iconName, className)} {...props} />;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLElement>;

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Icon);
